import { api } from "@/api"
import type { ProductTagColor } from "./productTagColors"
export type ProductTag = DeepReadonly<{
  id: string
  label: string
  color: ProductTagColor
  isHidden: boolean
}>

export const listProductTags = async (): Promise<
  ProductTag[]
> => {
  const response = await api.get<ProductTag[]>(
    "/products/product-tags/"
  )
  return response.body
}
